/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import  ENTERPRISE_ID_EVENT_TYPE  from './constant/eventType';

const ENTERPRISE_EVENTS = ENTERPRISE_ID_EVENT_TYPE;
export default ENTERPRISE_EVENTS;
